import React, { memo, useEffect, useRef, useState } from 'react';
import { DropDownArrow } from '@yme/assets/icons';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { buildKey } from '@yme/common/index';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel4 } from '@yme/tokens/typography';
import { keyCodes } from '@yme/utils/constants';
import { HEIGHT_OF_ITEM, MAXIMUM_VISIBLE_ITEMS } from './constants';
import { getDirectionDropDownShow } from './helpers';
import { DropDownItemStyled, DropDownListStyled, DropDownListWrapperStyled, DropDownStyled, SelectedOptionTitleStyled, SimpleDropDownStyled, SVGIconStyled, } from './styled';
// TODO: (D.K.) Needs merge this SimpleDropDown with default DropDown
function SimpleDropDownComponent({ defaultOption, options = [], selectedOption, setSelectedOption, dropDownTitle = undefined, leftSideIconType = undefined, isRightToLeft = false, maxItemsVisible = MAXIMUM_VISIBLE_ITEMS, defaultDropDownWidth = '100%', isDisabled: isDropDownDisabled = false, dataTestId = 'simpleDropDown', color, isArrowHidden, className, DropDownControlButton = DropDownStyled, }) {
    const [isDropDownExpanded, setIsDropDownExpanded] = useState(false);
    const [isUpwardDirection, setIsUpwardDirection] = useState(false);
    const dropDownListRef = useRef(null);
    const dropDownRef = useRef(null);
    const onClickHandler = (option) => {
        setSelectedOption(option);
        setIsDropDownExpanded(false);
    };
    useEffect(() => {
        if (defaultOption) {
            setSelectedOption(defaultOption);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onClickDropDownHandler = () => {
        if (!isDropDownDisabled) {
            setIsDropDownExpanded(!isDropDownExpanded);
            const { isTopDirectionFirst, isTopDirectionSecond } = getDirectionDropDownShow({
                maxItemsVisible,
                ref: dropDownRef,
            });
            if (!isTopDirectionFirst && isTopDirectionSecond) {
                setIsUpwardDirection(true);
            }
            else {
                setIsUpwardDirection(false);
            }
        }
    };
    const onKeyDownHandler = (event) => {
        if (event.key === keyCodes.ENTER || event.key === keyCodes.ESCAPE) {
            onClickDropDownHandler();
        }
    };
    const onBlurHandler = (isLast) => () => {
        if (isLast) {
            setIsDropDownExpanded(false);
        }
    };
    useEffect(() => {
        const handleClickOutside = (e) => {
            const isOutsideClick = dropDownListRef?.current &&
                !dropDownListRef.current?.contains(e.target) &&
                !dropDownRef.current?.contains(e.target);
            if (isOutsideClick) {
                setIsDropDownExpanded(false);
            }
        };
        window.addEventListener('mousedown', handleClickOutside);
        return () => {
            window.removeEventListener('mousedown', handleClickOutside);
        };
    }, [dropDownListRef, dropDownRef]);
    if (options?.length >= 0) {
        return (React.createElement(SimpleDropDownStyled, { defaultDropDownWidth: defaultDropDownWidth, isDisabled: isDropDownDisabled, "data-testid": dataTestId, className: className },
            dropDownTitle && (React.createElement(FlexWrapper, { mb: "4px" },
                React.createElement(RegularTextLevel4, null, dropDownTitle))),
            React.createElement(DropDownControlButton, { onClick: onClickDropDownHandler, ref: dropDownRef, isDropDownExpanded: isDropDownExpanded, tabIndex: 0, onKeyDown: onKeyDownHandler, isDisabled: isDropDownDisabled },
                leftSideIconType && React.createElement(SVGIcon, { type: leftSideIconType }),
                React.createElement(SelectedOptionTitleStyled, { isEllipsisEndingLine: true, color: color }, selectedOption.label),
                !isArrowHidden && (React.createElement(SVGIconStyled, { type: DropDownArrow, isDropDownExpanded: isDropDownExpanded }))),
            Boolean(options?.length) && (React.createElement(DropDownListWrapperStyled, { isDropDownExpanded: isDropDownExpanded, ref: dropDownListRef, isTopDirection: isUpwardDirection },
                React.createElement(DropDownListStyled, { withScroll: options?.length >= maxItemsVisible, customMaxHeight: `${HEIGHT_OF_ITEM * maxItemsVisible}px`, isRightToLeft: isRightToLeft }, options?.map((itemOption, index) => {
                    const { value, label } = itemOption;
                    const isActiveItem = selectedOption.label === label;
                    const isItemOptionDisabled = Boolean(itemOption?.isDisabled);
                    return (React.createElement(DropDownItemStyled, { key: buildKey(value, index), onClick: () => !isActiveItem && !isItemOptionDisabled && onClickHandler(itemOption), isActiveTab: isActiveItem, isDisabled: isItemOptionDisabled, tabIndex: 0, onBlur: onBlurHandler(options.length - 1 === index) },
                        React.createElement(RegularTextLevel4, { isEllipsisEndingLine: true }, label)));
                }))))));
    }
    return null;
}
export const SimpleDropDown = memo(SimpleDropDownComponent);
SimpleDropDown.displayName = 'SimpleDropDown_Atom';
